import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import ContactBoxes from '../components/ContactBoxes';
import { COMPANY_INFO } from '../data/mockData';

export default function AboutPage() {
  return (
    <div className="space-y-16 pb-16">
      <SEO 
        title="Om K-TO Multiservice | Fyn og Jyllands foretrukne ventilationsservice"
        description="Med 25 års erfaring i ventilationsbranchen har K-TO Multiservice udført mange forskellige opgaver for erhvervskunder i Jylland og på Fyn."
        slug="/k-to-ventilationsteknik"
        image="https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-8-1024x683.jpg"
        exact={true}
      />

      {/* Page Header */}
      <section className="bg-slate-900 text-white py-16 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-sky-500/20 text-sky-300 text-xs font-bold uppercase tracking-wider border border-sky-500/30">
            <i className="fa-solid fa-circle-info text-sky-400" aria-hidden="true"></i>
            <span>Firmaprofil</span>
          </div>

          <h1 className="text-3xl sm:text-5xl font-black tracking-tight text-white">
            K-TO Ventilationsteknik
          </h1>

          <p className="text-slate-300 text-base sm:text-lg max-w-3xl leading-relaxed">
            Fyn og Jyllands foretrukne ventilationspartner med 30 års erfaring i indregulering, service, fejlfinding og indeklima.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          <div className="lg:col-span-8 space-y-8">
            <div className="bg-white rounded-3xl p-8 sm:p-10 border border-slate-200/90 shadow-sm space-y-6">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                Vores firmaprofil
              </h2>

              <div className="prose prose-slate max-w-none text-slate-700 leading-relaxed space-y-4">
                <p className="text-lg font-semibold text-slate-900">
                  Hos K-TO Ventilationsteknik udfører vi mange forskellige opgaver, primært med udgangspunkt i ventilation og opgaver vedrørende indeklima.
                </p>
                <p>
                  Vi har 30 års erfaring i arbejdet med indregulering, service og fejlfinding af ventilations- og køleanlæg. Da vi ofte kommer i berøring med andre faggrene inden for byggeri og renovering, kan vi også varetage disse opgaver med hjælp fra vores dygtige samarbejdspartnere.
                </p>
                <p>
                  Vi arbejder primært for erhvervskunder, produktionsvirksomheder, kontorer, institutioner og ejendomsdrift på Jylland og Fyn, men vi står også gerne til rådighed for kunder, der ønsker vores specialiserede hjælp.
                </p>
                <p>
                  Giv os et kald, eller skriv om dit projekt eller din konkrete opgave – så finder vi en løsning sammen, som er tilfredstillende, og som vil være holdbar langt ind i fremtiden. Du er altid velkommen til at kontakte os for en snak om dine muligheder og et uforpligtende tilbud.
                </p>
              </div>

              {/* Legal Note */}
              <div className="p-4 rounded-2xl bg-slate-50 border border-slate-200 text-xs text-slate-500 space-y-1">
                <p>Virksomhedsinformation:</p>
                <p className="font-semibold text-slate-700">
                  Markedsføringsnavn: {COMPANY_INFO.brandName} • Juridisk navn: {COMPANY_INFO.legalName} • CVR: {COMPANY_INFO.cvr}
                </p>
                <p>Adresse: {COMPANY_INFO.fullAddress}</p>
              </div>
            </div>

            {/* Core Pillars */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm space-y-2">
                <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-600 flex items-center justify-center font-bold text-lg mb-3">
                  <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                </div>
                <h3 className="font-bold text-lg text-slate-900">Placeret i Børkop</h3>
                <p className="text-xs text-slate-600 leading-relaxed">
                  Firmaet er beliggende i Børkop (Trekantsområdet), og vi servicerer hurtigt og effektivt kunder i både Jylland og på Fyn.
                </p>
              </div>

              <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm space-y-2">
                <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-600 flex items-center justify-center font-bold text-lg mb-3">
                  <i className="fa-solid fa-award" aria-hidden="true"></i>
                </div>
                <h3 className="font-bold text-lg text-slate-900">30 års erfaring & ekspertise</h3>
                <p className="text-xs text-slate-600 leading-relaxed">
                  Hos K-TO Ventilationsteknik har vi 30 års erfaring inden for ventilationsbranchen, og vi tilpasser altid løsningen efter jeres behov.
                </p>
              </div>

              <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm space-y-2">
                <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-600 flex items-center justify-center font-bold text-lg mb-3">
                  <i className="fa-solid fa-comments" aria-hidden="true"></i>
                </div>
                <h3 className="font-bold text-lg text-slate-900">Service i høj kvalitet</h3>
                <p className="text-xs text-slate-600 leading-relaxed">
                  Hos os er servicen og kommunikationen i top, og vi sørger altid for at udføre opgaverne på professionel og omhyggelig vis.
                </p>
              </div>

              <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm space-y-2">
                <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-600 flex items-center justify-center font-bold text-lg mb-3">
                  <i className="fa-solid fa-file-contract" aria-hidden="true"></i>
                </div>
                <h3 className="font-bold text-lg text-slate-900">Serviceaftaler</h3>
                <p className="text-xs text-slate-600 leading-relaxed">
                  Få en fast serviceaftale, så I slipper for selv at huske på eftersynsintervaller. Vi kontakter jer i god tid før hvert servicetjek.
                </p>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4 space-y-6">
            <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-md bg-white">
              <img 
                src="https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilation-montage.jpg" 
                alt="Servicetekniker K-TO Ventilationsteknik" 
                className="w-full h-80 object-cover object-top"
              />
              <div className="p-6 space-y-3">
                <span className="text-xs font-bold text-sky-600 uppercase tracking-wider block">
                  Erfaren Servicetekniker
                </span>
                <p className="text-sm font-semibold text-slate-800">
                  Udfører opgaverne direkte på stedet med professionelt måleudstyr.
                </p>
              </div>
            </div>

            <div className="bg-slate-900 text-white rounded-3xl p-6 border border-slate-800 space-y-4">
              <h3 className="text-lg font-extrabold text-white">Har I spørgsmål?</h3>
              <p className="text-xs text-slate-300 leading-relaxed">
                Kontakt os for en uforpligtende samtale om jeres anlæg.
              </p>
              <a
                href={`tel:${COMPANY_INFO.phoneRaw}`}
                className="w-full bg-sky-600 hover:bg-sky-500 text-white font-bold text-xs uppercase tracking-wider py-3 rounded-xl transition-colors flex items-center justify-center gap-2 block text-center"
              >
                <i className="fa-solid fa-phone" aria-hidden="true"></i>
                <span>Ring på 22 72 87 23</span>
              </a>
            </div>
          </div>

        </div>
      </section>

      {/* Contact Boxes */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ContactBoxes />
      </section>
    </div>
  );
}
